import component from './PageAside.vue'
export default component
